module.exports = __webpack_public_path__ + "img/r-164.2897c973.jpg";